import React from 'react';
import styled, { css } from 'styled-components';
import CoreAlert from 'gatsby-theme-core/src/components/alert';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import useSite from 'gatsby-theme-core/src/hooks/use-site';

const Alert = ({ className }) => {
  const { alert } = useSite();

  if (!alert?.data?.childMarkdownRemark?.html) {
    return null;
  }

  return (
    <StyledCoreAlert $noAnimation className={className} $info>
      <Container>
        <StyledContent $content={alert} />
      </Container>
    </StyledCoreAlert>
  );
};

const StyledContent = styled(Content)`
  p {
    margin: 0;
    line-height: 150%;
  }
  && a {
    font-weight: 700;
    color: inherit;
    text-decoration: underline;
  }
`;

const StyledCoreAlert = styled(CoreAlert)`
  margin-top: 0;

  ${({ $info }) => $info && css`
    background-color: #d6ebff;
    color: #256994;
    border: 1px solid #d6ebff;
  `}
`;

export default styled(Alert)`
  min-height: 1rem;
`;
